import { Icon, IconName } from '@blueprintjs/core'
import classNames from 'classnames'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { NavLink } from 'react-router-dom'

import * as fromStore from '../../../modules/signal-r/store'

import { DispatchProp } from '../../../modules/store'

import { ActivityIndicator, isEmpty, isPresent } from '../../shared'

type NotifyProp = {
  notifyWhen?: string[]
}

type Props = OwnProps & NotifyProp

type OwnProps = {
  to: string
  icon: IconName | JSX.Element
  label: string
  dataTest?: string
  shortcuttedLabel?: boolean
  activeClassName?: string
  isActive?: boolean
}

export class ActivityBarNavlink extends Component<Props> {
  render() {
    const {
      to,
      icon,
      label,
      dataTest = '',
      activeClassName = 'activity-bar__navlink--active',
      shortcuttedLabel = false,
      isActive = false,
    } = this.props

    const labelClassName = classNames('activity-bar__label', {
      'activity-bar__label--shortcutted': shortcuttedLabel,
    })

    const navLinkClassName = classNames('activity-bar__navlink', {
      'activity-bar__navlink--active': isActive,
    })

    return (
      <NavLink
        to={to}
        data-test={dataTest}
        className={classNames(navLinkClassName, `${navLinkClassName}-${label.toLowerCase()}`)}
        activeClassName={activeClassName}
      >
        {isPresent(this.props.notifyWhen) && <EnhancedIndicator notifyWhen={this.props.notifyWhen} />}
        <Icon iconSize={32} icon={icon} title={false} />
        <p className={labelClassName}>{label}</p>
      </NavLink>
    )
  }
}

type IndicatorProps = IndicatorStateProps & DispatchProp & NotifyProp

type IndicatorStateProps = {
  signalRData: fromStore.SignalRState
}

const mapStateToProps = (state: fromStore.SignalRState) => {
  return {
    signalRData: fromStore.getSignalRData(state),
  }
}
const enhance = connect(mapStateToProps)
class Indicator extends Component<IndicatorProps> {
  render() {
    const { notifyWhen = [] } = this.props

    if (isEmpty(notifyWhen) || true) {
      return null
    }

    return shouldRenderIndicator(this.props.signalRData, notifyWhen) ? <ActivityIndicator /> : null
  }
}

const EnhancedIndicator = enhance(Indicator)

function shouldRenderIndicator(signalRData: fromStore.SignalRState, notifyWhen: string[]): boolean {
  return notifyWhen.some((signalName: string) => isPresent(signalRData[signalName]) && signalRData[signalName] > 0)
}



// WEBPACK FOOTER //
// ./src/app/shared/components/activity-bar-navlink.tsx